import { GET_SHIPMENT_LABEL_SUCCESS, GET_SHIPMENT_LABEL_REQUEST, GET_SHIPMENT_LABEL_FAILURE } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getShipmentLabelReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SHIPMENT_LABEL_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_SHIPMENT_LABEL_REQUEST:
            return Object.assign({}, state);
        case GET_SHIPMENT_LABEL_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getShipmentLabelReducer;
